import { render, staticRenderFns } from "./mmqueryModal.vue?vue&type=template&id=47f7070e"
import script from "./mmqueryModal.vue?vue&type=script&lang=js"
export * from "./mmqueryModal.vue?vue&type=script&lang=js"
import style0 from "./mmqueryModal.vue?vue&type=style&index=0&id=47f7070e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports